import { useState } from "react";
import { LCAppBar } from "./LCAppBar";
import { MainWindow } from './MainWindow';
import { Stack } from "@mui/material";
import Box from '@mui/material/Box';




export let returnStack = [];


export const LinuxCafe = (props) => {


    // console.log('Kleidermarkt-entered', props);
    const [openPage, setOpenPage] = useState('welcome');


    const handleOpenPage = (p) => {
        // console.log("handleOpenPage:", p)
        returnStack.push(openPage);
        // console.log("returnStack:", returnStack);
        setOpenPage(p);
    };

    const handleClosePage = () => {
        const ret = returnStack.pop();
        // console.log("handleClosePage returns to:", ret)

        if (ret?.main !== 'registerSeller') {
            setOpenPage(ret || { "main": "welcome" });
        } else {
            setOpenPage({ "main": "welcome" });
        }
    };



    return (
        <>
            <LCAppBar
                handleOpenPage={handleOpenPage}
                openPage={openPage}
            />

            <Stack direction="row" spacing={2} sx={{ width: 1 }}>
                <Box sx={{ flexGrow: 1, width: 0.15, display: { xs: 'none', md: 'flex' } }} />
                <MainWindow
                    openPage={openPage}
                    handleClosePage={handleClosePage}
                    // articleType={articleType}
                    // setArticleType={[setArticleType]}
                    handleOpenPage={handleOpenPage}
                />
                <Box sx={{ flexGrow: 1, width: 0.15, display: { xs: 'none', md: 'flex' } }} />
            </Stack>
        </>
    )
}
